"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBlockState = void 0;
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var NeighbourhoodInfo_init_1 = require("@/pages/place/states/NeighbourhoodInfo.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var DevelopmentDetails_init_1 = require("@/pages/development/states/DevelopmentDetails.init");
var PlaceTranslate_init_1 = require("@/pages/place/states/PlaceTranslate.init");
var PlaceFaqItem_init_1 = require("@/pages/place/states/PlaceFaqItem.init");
var PlaceAvailableState_init_1 = require("@/pages/place/states/PlaceAvailableState.init");
var PlaceTopPlace_init_1 = require("@/pages/place/states/PlaceTopPlace.init");
var DetailVideo_init_1 = require("@/pages/detail/states/DetailVideo.init");
var DetailVideoPlayer_init_1 = require("@/pages/detail/states/DetailVideoPlayer.init");
exports.defaultBlockState = {
    id: 12345,
    name: 'South Horizon',
    nameMain: 'South Horizon',
    nameAlt: '海怡半島',
    parentName: 'Aberdeen',
    address: 'South Horizon Drive, Aberdeen',
    district: 'Aberdeen',
    about: "Joined units on high floor with unusually wide and unblocked sea views in different rooms and in living rooms. Less than HALF a minute walk from tower lobby to MTR entrance. Asking price considerably lower than bank's valuations and landlord gives away a carpark to the buyer of this unit",
    lat: 22.2440841,
    lng: 114.1472304,
    galleryPop: PlaceState_1.GalleryPopState.NONE,
    mapType: GoogleMap_1.GoogleMapType.ROADMAP,
    neighbourhood: NeighbourhoodInfo_init_1.defaultNeighbourhoodInfoState,
    similarProperties: ResultPageState_init_1.defaultResultItems,
    type: SfilterTypeGroup_1.SfilterType.ALL,
    isSticky: false,
    keyDetails: DevelopmentDetails_init_1.defaultDevelopmentDetails.developmentMetas,
    currentUrl: '',
    districtUrl: '/en-us',
    availablePropertiesRent: ResultPageState_init_1.newForRent,
    availablePropertiesSale: ResultPageState_init_1.forSaleOnly,
    availableRentSort: PlaceState_1.AvailableSortType.QUALITY_SCORE,
    availableRentOrder: PlaceState_1.AvailableSortOrder.DESC,
    availableSaleSort: PlaceState_1.AvailableSortType.QUALITY_SCORE,
    availableSaleOrder: PlaceState_1.AvailableSortOrder.DESC,
    availableShowBuildingName: false,
    t: PlaceTranslate_init_1.defaultPlaceTranslate,
    districtInfo: [
        { key: 'Main', value: ['111', '12312312'] },
        { key: 'Transport', value: ['222'] },
        { key: 'Schools', value: ['333'] },
    ],
    currentDistrictInfo: 0,
    forRentCount: 20,
    forSaleCount: 20,
    medianLeasePrice: 54000,
    medianSalePpsf: 12000,
    galleryItems: [
        {
            src: DetailVideo_init_1.defaultDetailVideo.src,
            thumb: DetailVideo_init_1.defaultDetailVideo.thumb,
            text: DetailVideo_init_1.defaultDetailVideo.caption,
        },
        {
            src: '/res/img/sliderimg/1.jpg',
            thumb: '/res/img/sliderimg/thumb-1.jpg',
            text: 'test 1',
        },
        {
            src: '/res/img/sliderimg/2.jpg',
            thumb: '/res/img/sliderimg/thumb-2.jpg',
            text: 'test 2',
        },
        {
            src: '/res/img/sliderimg/3.jpg',
            thumb: '/res/img/sliderimg/thumb-3.jpg',
            text: 'test 3',
        },
        {
            src: '/res/img/sliderimg/4.jpg',
            thumb: '/res/img/sliderimg/thumb-4.jpg',
            text: 'test 4',
        },
        {
            src: '/res/img/sliderimg/5.jpg',
            thumb: '/res/img/sliderimg/thumb-5.jpg',
            text: 'test 5',
        },
        {
            src: '/res/img/sliderimg/6.jpg',
            thumb: '/res/img/sliderimg/thumb-6.jpg',
            text: 'test 6',
        },
    ],
    galleryFullWidth: '400px',
    tFeature: {
        featureSecurity24: '24 Hours Security',
        featureSecurityDaytime: 'Day Time Security',
        featureAllowPets: 'Allow Pets',
        featureBbq: 'Barbeque Area',
        featureClubHouse: 'Club House',
        featureConvenienceStore: 'Convenience Store',
        featureCourtBadminton: 'Badminton Court',
        featureCourtBb: 'Basketball Court',
        featureCourtSquash: 'Squash Court',
        featureCourtTennis: 'Tennis Court',
        featureGolfSim: 'Golf Simulator',
        featureGym: 'GYM',
        featurePlayground: 'Playground',
        featurePoolOutdoor: 'Outdoor Swimming Pool',
        featurePoolIndoor: 'Indoor Swimming Pool',
        featureRoomFunction: 'Function Room',
        featureRoomMultiPurpose: 'Multi-purpose Room',
        featureRoomSnooker: 'Snooker',
        featureShuttleBus: 'Shuttle Bus',
        featureTableTennis: 'Table Tennis',
        featureCarpark: 'Car Park',
    },
    features: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 23],
    saveSearchId: -1,
    districtPage: 12,
    isDemolished: false,
    viewRentLink: '',
    viewSaleLink: '',
    galleryIndex: 0,
    topPlaces: [
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
        PlaceTopPlace_init_1.defaultPlaceTopPlace,
    ],
    resultPageTranslation: ResultPageState_init_1.defaultResultPageState.t,
    faqs: PlaceFaqItem_init_1.defaultPlaceFaqItemState,
    textImages: PlaceAvailableState_init_1.defaultPlaceAvailableTextImagesEn,
    followPopupActive: false,
    showDistrictLink: true,
    viewSaleLinkOfDistrict: '/en/property-search/buy/wan-chai',
    viewRentLinkOfDistrict: '/en/property-search/rent/wan-chai',
    mapReady: false,
    factsMore: false,
    featuresMore: false,
    aboutMore: false,
    mapSearchBuyLink: 'google.com',
    mapSearchRentLink: 'yahoo.com',
    showContactCta: true,
    videoPlayer: DetailVideoPlayer_init_1.defaultDetailVideoPlayer,
    videos: DetailVideo_init_1.defaultDetailVideos,
    isVideoPopActive: false,
};
